import React from 'react';
import { Scale, X, Check } from 'lucide-react';
const rows = [{
  sin: 'Sesiones improvisadas sin método',
  con: 'Protocolo claro para cada tipo de dificultad'
}, {
  sin: 'Tensión acumulada y relación dañada',
  con: 'Sesiones que terminan en victorias pequeñas'
}, {
  sin: 'Silabeo sin atacar la raíz real',
  con: 'Método de bloques que corrige desde adentro'
}, {
  sin: 'Creencia de "soy malo para leer" instalada',
  con: 'Reencuadre del error como parte del proceso'
}, {
  sin: 'Videos de YouTube que se contradicen',
  con: 'Sistema secuenciado con lógica progresiva'
}, {
  sin: 'Sin frases correctas para los momentos difíciles',
  con: 'Scripts exactos para cada situación'
}, {
  sin: 'Sin saber si realmente mejora',
  con: 'Checklist de señales reales de progreso'
}, {
  sin: 'Sin rutina fija que sostenga el avance',
  con: 'Hábito de 10 minutos instalado en 21 días'
}, {
  sin: 'Cada sesión deja un recuerdo negativo',
  con: 'Cierre positivo que hace querer volver mañana'
}, {
  sin: 'Sin diagnóstico del bloqueo real',
  con: 'Ayuda que llega exactamente donde se necesita'
}];
export function CostOfInaction() {
  return <section className="py-12 md:py-16 bg-white" data-id="element-45">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-46">
        <div className="text-center mb-10" data-id="element-47">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-slate-100 rounded-full mb-6" data-id="element-48">
            <Scale className="w-8 h-8 text-slate-600" data-id="element-49" />
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-navy mb-4" data-id="element-50">
            ¿CUÁNTO CUESTA NO TENERLO?
          </h2>
        </div>

        <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-slate-200" data-id="element-51">
          <div className="grid grid-cols-2" data-id="element-52">
            <div className="bg-rose-50/50 p-6 text-center border-b border-r border-slate-200" data-id="element-53">
              <h3 className="font-bold text-rose-900 flex items-center justify-center gap-2" data-id="element-54">
                <X className="w-5 h-5 text-rose-500" data-id="element-55" /> Sin el MegaPack
              </h3>
            </div>
            <div className="bg-emerald-50/50 p-6 text-center border-b border-slate-200" data-id="element-56">
              <h3 className="font-bold text-emerald-900 flex items-center justify-center gap-2" data-id="element-57">
                <Check className="w-5 h-5 text-emerald-500" data-id="element-58" /> Con el MegaPack
              </h3>
            </div>
          </div>

          <div className="divide-y divide-slate-100" data-id="element-59">
            {rows.map((row, i) => <div key={i} className="grid grid-cols-2 hover:bg-slate-50 transition-colors" data-id="element-60">
                <div className="p-4 md:p-6 text-sm md:text-base text-slate-600 border-r border-slate-100 flex items-center" data-id="element-61">
                  {row.sin}
                </div>
                <div className="p-4 md:p-6 text-sm md:text-base font-medium text-navy flex items-center bg-emerald-50/20" data-id="element-62">
                  {row.con}
                </div>
              </div>)}
          </div>
        </div>

        <div className="text-center mt-12" data-id="element-63">
          <p className="text-2xl font-heading italic text-gold-600" data-id="element-64">
            La próxima sesión de lectura puede ser completamente diferente.
          </p>
        </div>
      </div>
    </section>;
}